import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';


import { ResetPasswordModel } from './reset.model'
import { ResetPasswordService } from './reset.service';
import { CustomValidators } from '../../shared/forms/custom-validators';


@Component({
  selector: 'reset',
  templateUrl: 'reset.component.html',
  providers: [ResetPasswordService]

})
export class ResetComponent implements OnInit {

  isLoading: boolean = false;
  resetPasswordForm: FormGroup;
  errorMessage = '';
  successMessage = '';

  private resetPasswordModel: ResetPasswordModel;
  private token: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _fb: FormBuilder,
    private _resetPasswordService: ResetPasswordService
  ) { }

  ngOnInit(): void {
    this._route.params.subscribe(params => {
      this.token = params['token'];
    });

    this.errorMessage = '';
    this.successMessage = '';
    this.resetPasswordForm = this._fb.group(
      {
        username: ['', Validators.compose([
          Validators.required,
          CustomValidators.email
        ])],
        password: ['', Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(15)
        ])],
        confirmPassword: ['', Validators.compose([
          Validators.required
        ])]
      },
      { validator: CustomValidators.controlsMatch('password', 'confirmPassword') }
    );
  }

  onSubmit(event): void {
    event.preventDefault();
    this.errorMessage = '';

    if (this.resetPasswordForm.valid) {
      this.isLoading = true;
      this.resetPasswordModel = this.resetPasswordForm.value;
      this.resetPasswordModel.token = this.token;
      this._resetPasswordService.updatePassword(this.resetPasswordModel)
        .finally(() => this.isLoading = false)
        .subscribe(
        () => this.successMessage = 'Tu contraseña se ha registrado correctamente, presiona en continuar o inicia sesión',
        err => this.errorMessage = err
        );
    }
  }

  redirectHome() {
    this._router.navigate(['landing/home']);
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/reset/reset.component.ts